export default "__VITE_ASSET___ptFBQH2__"